import React, { createContext, useCallback, useContext } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { usePersistedState } from '../api/localStore'
import { useAdvancedEnabled } from '../useAdvancedEnabled'

type AdvancedModeState = [boolean, (on: boolean) => void]

const AdvancedModeContext = createContext<AdvancedModeState | null>(null)

const STORAGE_KEY = 'advanced.dashboardMode.v1'

export const AdvancedModeProvider = ({ children }: { children: React.ReactNode }) => {
  const [advancedMode, setAdvancedMode] = usePersistedState<boolean>(STORAGE_KEY, false)
  const set = useCallback((on: boolean) => setAdvancedMode(on), [setAdvancedMode])

  return <AdvancedModeContext.Provider value={[advancedMode, set]}>{children}</AdvancedModeContext.Provider>
}

export const useAdvancedMode = (): AdvancedModeState => {
  const state = useContext(AdvancedModeContext)
  if (!state) {
    throw new Error('useAdvancedMode must be used within AdvancedModeProvider')
  }
  return state
}

export const useShowAdvancedChrome = (): boolean => {
  const [advancedMode] = useAdvancedMode()
  const { pathname } = useLocation()
  const advancedRoute = matchPath(pathname, { path: ['/advanced', '/advanced-config'] }) !== null
  return useAdvancedEnabled() && (advancedMode || advancedRoute)
}
